"use strict";

exports.__esModule = true;
exports["default"] = ProductConsumer;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ProductConsumer(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.023 4.46a.019.019 0 0 0-.019.019v1.459c0 .01.008.019.019.019h15.953c.01 0 .019-.008.019-.019V4.479a.019.019 0 0 0-.019-.019H8.023zm0 3.985a.019.019 0 0 0-.019.019v1.459c0 .01.008.019.019.019h15.953c.01 0 .019-.008.019-.019V8.464a.019.019 0 0 0-.019-.019H8.023zm-.005 3.985a.013.013 0 0 0-.013.013v1.469c0 .007.006.013.013.013h4.974a.013.013 0 0 0 .013-.013v-1.469a.013.013 0 0 0-.013-.013H8.018zM24.558.063H7.442a2.503 2.503 0 0 0-2.505 2.503v26.868a2.505 2.505 0 0 0 2.505 2.505h17.115a2.505 2.505 0 0 0 2.505-2.505v-5.211l.001-16.416V2.566A2.503 2.503 0 0 0 24.558.063zM17.363 29.82h-2.728a1.102 1.102 0 1 1 0-2.206h2.728a1.104 1.104 0 1 1 0 2.206zm7.959-4.205H6.677V2.566c0-.421.343-.765.766-.765h17.115c.423 0 .765.344.765.765l-.001 23.049z"
  }));
}